<div class="modal-content">
  <!-- Cabeçalho do Modal com título e botão de fechar -->
  <div class="modal-header">
    <h5 class="modal-title">
      {{ eventForm ? "Editar Feira" : "Adicionar feira" }}
    </h5>
    <button
      type="button"
      class="btn-close"
      aria-label="Fechar"
      (click)="activeModal.dismiss()"
    ></button>
  </div>

  <div class="modal-body p-4">
    <form [formGroup]="eventForm" (ngSubmit)="onSubmit()">
      <!-- Campo Nome -->
      <div class="mb-3">
        <label class="form-label">Nome</label>
        <input
          class="form-control"
          placeholder="Digite o nome da feira"
          type="text"
          formControlName="nome"
          [ngClass]="{
            'is-invalid':
              eventForm.controls.nome.touched && eventForm.controls.nome.errors,
          }"
        />
        <div
          class="invalid-feedback"
          *ngIf="
            eventForm.controls.nome.touched && eventForm.controls.nome.errors
          "
        >
          O nome é obrigatório.
        </div>
      </div>
      <!-- Botão de Enviar -->
      <div class="text-end">
        <button type="submit" class="btn btn-success w-md">
          {{ event ? "Atualizar" : "Salvar" }}
        </button>
      </div>
    </form>
  </div>
</div>
